/** @file Dopesheet wheel: Mod zooms time at the cursor, Shift or a sideways wheel pans, else rows scroll. */
import { clamp } from '@pose2d/math/clamp';
import { timelineScale } from '@pose2d/editor-geometry/timelineScale';
import type { TimelineScale } from '@pose2d/editor-geometry/types';

/** A wheel event in canvas CSS px (deltas in px, positive = down / right). */
export interface DopeWheelEvent {
  x: number;
  dx: number;
  dy: number;
  mod: boolean;
  shift: boolean;
}

/** Zoom factor per wheel pixel (100 px of wheel ≈ 1.22×). */
const ZOOM_PER_PX = 0.002;

/** The next time scale and row scroll; `maxScroll` is the rows' content height minus the rows area height. */
export function dopeWheel(scale: TimelineScale, scrollY: number, maxScroll: number, e: DopeWheelEvent): { scale: TimelineScale; scrollY: number } {
  if (e.mod) return { scale: timelineScale.zoomAt(scale, e.x, Math.exp(-e.dy * ZOOM_PER_PX)), scrollY };
  const sideways = e.shift ? e.dy : e.dx;
  const down = e.shift ? 0 : e.dy;
  return { scale: timelineScale.pan(scale, -sideways), scrollY: clamp(scrollY + down, 0, Math.max(0, maxScroll)) };
}
